module.exports = __webpack_public_path__ + "media/images/icon-nodata-f7d3cbaf6b3a87a6f194346dd44805a9.png";